let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aOdaf")).then(() => parcelRequire('3o50X'));